import {useMutation, useQuery} from 'admin/lib/apollo'
import {GET_DEBIT, CREATE_DEBIT, UPDATE_DEBIT} from 'admin/gql/Debit.gql'
import clearCache from './clearCache'
import useDestroyable from 'admin/hooks/useDestroyable'

export default (organisationId, accountId, debitId) => {
  const {data: {debit = {}} = {}, error: getError} = useQuery(GET_DEBIT, {
    variables: {organisationId, debitId},
    skip: !debitId
  })

  const [create, {error: createError}] = useMutation(CREATE_DEBIT, {
    variables: {organisationId, accountId},
    flash: 'Debit created',
    update: (cache, {errors}) => !errors && clearCache({statement: {accountId}})(cache)
  })

  const [update, {error: updateError}] = useMutation(UPDATE_DEBIT, {
    variables: {organisationId, accountId, debitId},
    flash: 'Debit updated',
    update: (cache, {errors}) =>
      !errors &&
      clearCache({
        history: {itemType: 'Debit', itemId: debitId},
        statement: {accountId}
      })(cache)
  })

  const {destroy, errors: destroyError} = useDestroyable('Debit', debitId)

  return {
    debit,
    errors: getError || createError || updateError || destroyError || {},
    create,
    update,
    destroy
  }
}
